export default __webpack_public_path__ + "static/media/bd8e1dcf06fe4f36ff6e0d5bec6092a91576593350853.c2d712d6.webp";